import script from "./AuditLog.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditLog.vue?vue&type=script&setup=true&lang=js"

import "./AuditLog.vue?vue&type=style&index=0&id=6a5dff19&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a5dff19"]])

export default __exports__